import React, { useEffect, useRef, useState } from 'react';
import { RiveColumnContent } from '@models/column';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { resolveImagePath } from '@helpers/gallery';
import { RiveComponent } from './RiveComponent';

const classes = {
    riveContainer: {
        width: '100%',
        height: '40vh',
    },
};

interface RiveColumnContentProps {
    content: RiveColumnContent;
    lazyLoad?: boolean;
}

export function RiveContent({ content, lazyLoad }: RiveColumnContentProps): JSX.Element | null {
    const [isInView, setIsInView] = useState(!lazyLoad);
    const containerRef = useRef<HTMLDivElement>(null);
    const { mediaUrlPrefix } = useStaticValues();

    useEffect(() => {
        if (!lazyLoad) {
            return;
        }

        const riveContainer = containerRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                    if (riveContainer) {
                        observer.unobserve(riveContainer);
                    }
                }
            },
            {
                rootMargin: '5px',
            }
        );

        if (riveContainer) {
            observer.observe(riveContainer);
        }

        return () => {
            if (lazyLoad && riveContainer) {
                observer.unobserve(riveContainer);
            }
        };
    }, [lazyLoad]);
    return (
        <div key={JSON.stringify(content)} ref={containerRef} css={classes.riveContainer}>
            {content.src && isInView ? (
                <RiveComponent {...content} src={resolveImagePath(mediaUrlPrefix, content.src)} />
            ) : null}
        </div>
    );
}
